import { useDialogManager } from '@patrianna/dialog-manager'
import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'store/hooks'
import { isLoggedInSelector } from 'store/modules/user/selectors'
import { getItemFormLocalStorageSelector, removeDataFromLocalStorage } from 'utils/localStorage'

export default function useResetWelcomeEmailTimer() {
  const dispatch = useAppDispatch()
  const shownSessionDialogs = useDialogManager('getShownSessionDialogs')
  const isWelcomeEmailShown = shownSessionDialogs.includes('WELCOME_EMAIL_SEND_DIALOG')

  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const sessionTimerId = useAppSelector((state) =>
    getItemFormLocalStorageSelector(state, 'WELCOME_EMAIL_DIALOG_TIMER_ID'),
  )

  useEffect(() => {
    if (isLoggedIn && !isWelcomeEmailShown) {
      dispatch(removeDataFromLocalStorage('WELCOME_EMAIL_DIALOG_TIMER_ID'))
      clearTimeout(sessionTimerId)
    }
  }, [isLoggedIn, isWelcomeEmailShown, sessionTimerId, dispatch])
}
